/**
embeddable-overview-map
*/


<template>
    <div>
        <div id="embed-overview-map"></div>

        <div class="main-map-overlay" v-if="showLoadingOverlay">
            <div>
                <h4>{{ loadingOverlayText }}</h4>
                <div class="overlay-spinner">
                    <div class="s-r1"></div><div class="s-r2"></div><div class="s-r3"></div><div class="s-r4"></div><div class="s-r5"></div>
                </div>
            </div>
        </div>

        <div class="embeddable-map-legend">
            <h4>Legend <font-awesome-icon v-bind:icon="legendIcon" v-on:click.prevent="legendVisible=!legendVisible"/></h4>

            <transition-group name="list" v-if="legendVisible" style="margin-top: 5px;">
                <div class="embeddable-legend-item" v-for="(layer, ref) in mapLayers" v-bind:key="layer.name">
                    <img v-bind:src="LegendGraphic(ref)" alt="">
                    <div>{{ layer.name }}</div>
                    <div class="clearfix"></div>
                </div>
            </transition-group>
        </div>
    </div>
</template>


<script>
// import store from "../store/_index";
import Vue from "vue";
import L from "leaflet";
const axios = require("axios");

import { MapBoxBackgroundMapping, AllClosures, AllMpas, PotentialFutureMeasures } from "../../js/map-layers.js";
import { legend } from "../../js/map-controls.js";
import { LegendGraphic } from "../../js/map-layers.js";
import { reduceLatLngPrecision } from "../../js/map-tools.js";
import EmbeddableMapQueryContent from "./embeddable-map-query-content.vue";

import { library } from "@fortawesome/fontawesome-svg-core";
import { faChevronUp, faChevronDown } from "@fortawesome/free-solid-svg-icons";
library.add(faChevronUp, faChevronDown);


export default {
    name: "embeddable-overview-map",
    components: {
        EmbeddableMapQueryContent
    },
    // store,
    props: {},
    data: function () {
        return {
            showLoadingOverlay: false,
            loadingOverlayText: "Loading data",
            legendVisible: true,
            mapLayers: {
                "embed_unrestricted": {layer: "embed_unrestricted", name: "Marine Protected Areas"},
                "embed_consultation": {layer: "embed_consultation", name: "Consultation in progress to ban bottom-towed gear"},
                "embed_banned": {layer: "embed_banned", name: "Bottom-towed fishing gear banned"},
            },
            LegendGraphic
        }
    },
    methods: {
        createMap: function () {
            const map = L.map("embed-overview-map", {
                crs: L.CRS.EPSG900913,
                zoomControl: false,
                zoomSnap: 0.2,
                // center: [55, -1.6],
                // zoom: 4,
                layers: [MapBoxBackgroundMapping]
            })

            map.fitBounds([
                [48, -10],
                [64, 1]
            ])

            // L.control.scale({position: "bottomright"}).addTo(map);
            map.addControl(L.control.zoom({position: "topright"}));
            AllMpas.addTo(map);
            AllClosures.addTo(map);
            PotentialFutureMeasures.addTo(map);

            legend({position: "bottomleft", domElement: this.$el.getElementsByClassName("embeddable-map-legend")[0]}).addTo(map);

            // todo: tie this to the same geojson as the reality check main map
            map.on("click", function(e) {
                var coarseLatLng = reduceLatLngPrecision(e.latlng, 4);
                this.queryMap(coarseLatLng, map);
            }.bind(this));
        },
        queryMap: function (latLng, mapObject) {
            this.loadingOverlayText = "Loading data";
            this.showLoadingOverlay = true;

            // noinspection JSUnresolvedVariable
            axios.get("/api/1/rc/query_map/", {
                    params: {
                        lat: latLng.lat,
                        lng: latLng.lng
                    }
                })
                .then((returned_data) => {
                    const dataToShow = returned_data.data.leader || returned_data.data.MPAs.MCZ.length > 0 ||
                        returned_data.data.MPAs.SAC.length > 0 || returned_data.data.MPAs.SPA.length > 0 ||
                        returned_data.data.MPAs.NCMPA.length > 0 || returned_data.data.demersal_byelaws.length > 0;

                    if (!dataToShow) {
                        this.loadingOverlayText = "No data here"

                        window.setTimeout(function () {
                            this.showLoadingOverlay = false;
                        }.bind(this), mparc.shortMessageTimeout);

                        return
                    }

                    this.showLoadingOverlay = false;

                    L.popup({minWidth: 300, maxWidth: 500}).setLatLng(latLng).openOn(mapObject).setContent("<div id='map-query-container'></div>");

                    // Now bind the query content Vue component to the new div created in the popup
                    const QueryContentComponent = Vue.extend(EmbeddableMapQueryContent)
                    const instance = new QueryContentComponent({propsData: {queryData: returned_data.data}})
                    instance.$mount("#map-query-container")

                    mapObject.panTo(latLng);
                })
                .catch((error) => {
                    if (error.response) {
                        this.loadingOverlayText = error.response.data;
                    } else {
                        this.loadingOverlayText = "Error";
                    }

                    window.setTimeout(function () {
                        this.showLoadingOverlay = false;
                    }.bind(this), mparc.shortMessageTimeout)
                })

        }
    },
    computed: {
        legendIcon: function () {
            if (this.legendVisible) {
                return ['fas', 'chevron-up']
            }
            return ['fas', 'chevron-down']
        }
    },
    watch: {},
    mounted: function () {
        this.$nextTick(function () {
            this.createMap();
        })
    }
}
</script>


<style lang="scss">
    @import "../../styles/variables";

    #embed-overview-map {
        position: absolute;
        top: 0; right: 0; bottom: 0; left: 0;
    }
</style>